import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ChipInput, InputWithLabel, Switch, Text, validateEmail } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ToggleCommunications = ({
  label,
  description,
  isActive,
  onChangeIsActive,
  defaultRecipient,
  onChangeRecipient,
  recipient,
  ccEmails,
  onChangeCcEmails,
  disabled,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [recipientEmailError, setRecipientEmailError] = useState(false)

  const handleChangeRecipientEmail = event => {
    onChangeRecipient(event.target.value)
    if (event.target.value === '') {
      setRecipientEmailError(false)
    } else {
      setRecipientEmailError(!validateEmail(event.target.value))
    }
  }

  return (
    <Styles.Container isActive={isActive}>
      <Switch
        checked={isActive || false}
        disabled={disabled}
        onChange={onChangeIsActive}
        label={<Text type="titleS">{label}</Text>}
      />
      {isActive && (
        <>
          <Text type="bodyMRegular">{description}</Text>
          <Styles.InputsContainer>
            <InputWithLabel
              fullWidth
              label={t('Destinatario')}
              placeholder={defaultRecipient}
              value={recipient}
              onChange={handleChangeRecipientEmail}
              backgroundColor={theme.colors.background.primary}
              error={recipientEmailError}
              helperText={recipientEmailError && t('Introduce un email válido')}
              disabled={disabled}
            />
            <ChipInput
              fullWidth
              label={t('Destinatarios en copia (Cc:)')}
              backgroundColor={theme.colors.background.primary}
              value={ccEmails}
              onChange={onChangeCcEmails}
              helperText={t('Añade más direcciones de email separándolas por comas (,)')}
              disabled={disabled}
            />
          </Styles.InputsContainer>
        </>
      )}
    </Styles.Container>
  )
}

export default ToggleCommunications
